import { type App, inject, ref, type Ref } from 'vue'

export type CookieStore = Ref<Record<string, any>>

const key = 'app.plugin.store.cookie'

export function installCookieStore(app: App): CookieStore {
    const cookies = ref<Record<string, any>>({})

    app.provide(key, cookies)

    return cookies
}

export function useCookieStore(): CookieStore {
    return inject(key) as CookieStore
}
